import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import { m as j } from "./tss-DN0acMKN.mjs";
import { B as f } from "./body-text-BiQwh5-U.mjs";
import { B as y } from "./box-C2SWs1cM.mjs";
import { I as A } from "./icon-tile-BJ1ib0c2.mjs";
import { B as T } from "./base-headline-Dw8BrcrM.mjs";
import { f as w } from "./index-LyFokDcn.mjs";
import { f as B } from "./format-base-props-8NDUNDcL.mjs";
import { A as z } from "./avatar-1JHdkfls.mjs";
const C = {
  "horizontal-bottom": {
    gridTemplateAreas: `
			"icon text"
			".    actions"
		`,
    gridTemplateColumns: "auto 1fr",
    gridTemplateRows: "1fr auto"
  },
  "horizontal-right": {
    gridTemplateAreas: `
			"icon text actions"
		`,
    gridTemplateColumns: "auto 1fr auto"
  },
  "vertical-bottom": {
    gridTemplateAreas: `
			"icon right"
			"text text"
			"actions actions"
		`,
    gridTemplateRows: "auto 1fr auto"
  },
  "vertical-right": {
    gridTemplateAreas: `
			"icon right"
			"text actions"
		`,
    gridTemplateColumns: "1fr auto"
  }
};
function S(e, n) {
  return n ? {
    display: "inline-grid",
    ...C[`${e}-${n}`]
  } : {
    gridTemplateAreas: e === "horizontal" ? '"icon text"' : `"icon right"
					   "text text"`,
    gridTemplateColumns: "auto 1fr",
    display: "inline-grid"
  };
}
const N = j()((e, n) => {
  const {
    constructs: a,
    mixins: { boxShadow: m },
    spacing: r
  } = e, { actionPlacement: p, actions: o, description: c, height: u, orientation: s, width: l } = n;
  return {
    root: {
      ...S(s, o.length ? p : void 0),
      backgroundColor: a.surface.neutral.inverted,
      border: `1px solid ${a.border.neutral.xWeak}`,
      borderRadius: r(2),
      boxShadow: m("300", a.surface.neutral.xxStrong),
      boxSizing: "border-box",
      gap: r(2),
      gridAutoRows: "min-content",
      height: u,
      padding: r(2),
      width: l
    },
    icon: {
      gridArea: "icon"
    },
    right: {
      gridArea: "right",
      justifySelf: "flex-end",
      "&:empty": {
        display: "none"
      }
    },
    textContainer: {
      alignSelf: s === "horizontal" && !c ? "center" : void 0,
      gridArea: "text"
    },
    text: {
      wordBreak: "break-word"
    },
    actions: {
      display: "flex",
      flexWrap: "wrap",
      gap: r(2),
      gridArea: "actions",
      rowGap: r(1)
    }
  };
});
function G(e) {
  const {
    actionPlacement: n = "bottom",
    actions: a = [],
    component: m = "div",
    description: r,
    height: p,
    icon: o,
    orientation: c = "vertical",
    right: u,
    title: s,
    titleSize: l = "small",
    variant: b,
    width: v,
    ...x
  } = e, { classes: i } = N({ actionPlacement: n, actions: a, description: r, height: p, orientation: c, titleSize: l, width: v }, { props: e });
  let d = "primary", g = "neutral-strong", h;
  switch (b) {
    case "muted":
      d = "neutral-medium", g = "neutral-medium", h = "secondary";
      break;
    default:
      d = "primary", g = "neutral-strong", h = void 0;
  }
  return w.ifFeature(
    "encore",
    /* @__PURE__ */ t.jsxs(
      y,
      {
        component: m,
        ...B(x),
        className: i.root,
        "data-fabric-component": x["data-fabric-component"] ? `${x["data-fabric-component"]} TileV2` : "TileV2",
        children: [
          o && /* @__PURE__ */ t.jsx("div", { className: i.icon, children: typeof o == "string" ? /* @__PURE__ */ t.jsx(A, { icon: o, size: 48, variant: h }) : o }),
          c === "vertical" ? /* @__PURE__ */ t.jsx("div", { className: i.right, children: u }) : null,
          /* @__PURE__ */ t.jsxs("div", { className: i.textContainer, children: [
            l === "small" ? /* @__PURE__ */ t.jsx(f, { color: d, weight: "medium", children: /* @__PURE__ */ t.jsx("span", { className: i.text, children: s }) }) : /* @__PURE__ */ t.jsx(T, { color: d, component: "p", size: l === "medium" ? "extra-small" : "medium", children: /* @__PURE__ */ t.jsx("span", { className: i.text, children: s }) }),
            r ? /* @__PURE__ */ t.jsx(f, { color: g, size: "extra-small", children: /* @__PURE__ */ t.jsx("span", { className: i.text, children: r }) }) : null
          ] }),
          a.length ? /* @__PURE__ */ t.jsx("div", { className: i.actions, children: a }) : null
        ]
      }
    ),
    null
  );
}
const H = (e) => /* @__PURE__ */ t.jsx(z, { ...e, size: 48 });
export {
  H as A,
  G as B
};
//# sourceMappingURL=avatar-Cf_y9mVA.mjs.map
